<template>
	<div class="top" style="padding-bottom: 20px;">
		<div class="header">
			<h2 style="padding: 10px 5px;">新增小程序用户</h2>
		</div>
		<div style="height:400px;width: 100%;" class="middle-row center">
			<div class="middle-column around" style="height:100%;width:50%;">
				<div class="input-group" style="width: 100%;">
					<span class="input-group-addon" style="width: 100px;">姓名</span>
					<input type="text" v-model="ownerName" class="form-control" placeholder="请输入姓名">
				</div>
				<div class="input-group" style="width: 100%;">
					<span class="input-group-addon" style="width: 100px;">账号</span>
					<input type="text" v-model="account" class="form-control" placeholder="请输入登录账号">
				</div>
				<div class="input-group" style="width: 100%;">
					<span class="input-group-addon" style="width: 100px;">初始密码</span>
					<input type="text" v-model="password" class="form-control" placeholder="请输入初始密码"
						disabled="disabled">
				</div>
				<!-- <div class="input-group" style="width: 100%;">
					<span class="input-group-addon" style="width: 100px;">账号类型</span>
					<input type="text" v-model="type" class="form-control" placeholder="请输入账号类型">
				</div> -->
				<div class="input-group" style="width: 100%;">
					<span class="input-group-addon" style="width: 100px;">用户角色</span>
					<select id="select" v-model="typeId" class="form-control">
						<option value="1">超级管理员</option>
						<option value="2">区域负责人</option>
						<option value="3">清洗公司</option>
					</select>
				</div>
				<div class="input-group" style="width: 100%;" v-if="typeId === '3'">
					<span class="input-group-addon" style="width: 100px;">所属公司</span>
					<input type="text" v-model="company" class="form-control" placeholder="请输入所属公司">
				</div>
				<div class="input-group" style="width: 100%;border: 1px solid #ccc;" v-if="typeId === '2'">
					<span class="input-group-addon" style="width: 100px;border: none; ">负责街道</span>
					<div class="form-control" style="border: none;background-color: #eee; text-align: left; display: inline;width: 150px;margin-left: 10px; margin-top: 5px;" v-for="street in streets" :key="street">
						<input type="checkbox" :id="'street-' + street" :value="street" v-model="selectedStreets">
						<label :for="'street-' + street">{{ street }}</label>
					</div>
				</div>
				<div class="input-group">
					<button type="button" class="btn btn-success" @click="addMiniUser">新增小程序用户</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { BaiduMap, BmMarker, BmCircle } from 'vue-baidu-map'
import { util } from '../../static/util.js'

export default {
	data() {
		return {
			ownerName: '',
			account: '',
			password: '123456',
			type: '',
			typeId: '1',
			company: '',
			street: '',
			streets: [
				'东山街道',
				'南黎街道',
				'曲阳街道',
				'渠沟镇',
				'任圩街道',
				'三堤口',
				'相南街道',
				'相山东街道',
				'相山西街道',
				'凤凰山经济开发区'
			],
			selectedStreets: []
		}
	},
	methods: {
		addMiniUser: function () {
			var login = {};
			login.ownerName = this.ownerName;
			login.account = this.account;
			login.password = this.password;
			login.typeId = this.typeId;
			if (login.typeId === '2') {
				login.street = this.selectedStreets.join('|')
			}
			if (login.typeId === '3') {
				login.company = this.company;
			}
			console.log(login)
			if (util.checkLogin(login)) {
				this.$http.post(this.GLOBAL.base + 'addMiniLogin',
					login
					, {
						emulateJSON: true
					}).then(function (res) {
						if (res.bodyText == 'success') {
							alert('成功添加小程序用户');
						} else {
							alert('小程序账号已存在，请修改');
						}
					}, function (res) {
						console.log(res);
					});
			}
		}
	},
	components: {},
}
</script>

<style></style>
